// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixFooter{padding-top:130px;padding-bottom:80px}@media only screen and (min-width: 1024px){div:has(div.fixFooter){overflow:hidden}div:has(div.fixFooter) footer{position:fixed;bottom:0;width:100%}}@media only screen and (max-width: 575px){.fixFooter{padding:98px 16px 48px 16px}}", ""]);
// Exports
module.exports = exports;
